/**
 * Swagger Lucor
 * Swagger Lucor
 *
 * OpenAPI spec version: 1.2.18
 * Contact: roger.cazangi@hotmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AnexoAvaliado } from '../model/anexoAvaliado';
import { Avaliacao } from '../model/avaliacao';
import { Avaliado } from '../model/avaliado';
import { ExportFilter } from '../model/exportFilter';
import { ImportacaoPlanilha } from '../model/importacaoPlanilha';
import { NewPerfil } from '../model/newPerfil';
import { ResultadoAnexosAvaliadosLote } from '../model/resultadoAnexosAvaliadosLote';
import { MicrosoftAspNetCoreMvcFileContentResult } from '../model/microsoftAspNetCoreMvcFileContentResult';
import { TipoAnexo } from '../model/tipoAnexo';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';

import { environment } from '../../environments/environment';


@Injectable()
export class AvaliacaoApiService {

    protected basePath = environment.apiBasePath;
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Incluir Anexos dos Avaliados em Lote
     * 
     * @param avaliacaoId 
     * @param upfiles 
     * @param sobrescreverExistentes 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1AvaliacaoAvaliacaoIdAvaliadosAnexosPostForm(avaliacaoId: number, upfiles?: Array<Blob>, sobrescreverExistentes?: boolean, observe?: 'body', reportProgress?: boolean): Observable<ResultadoAnexosAvaliadosLote>;
    public v1AvaliacaoAvaliacaoIdAvaliadosAnexosPostForm(avaliacaoId: number, upfiles?: Array<Blob>, sobrescreverExistentes?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResultadoAnexosAvaliadosLote>>;
    public v1AvaliacaoAvaliacaoIdAvaliadosAnexosPostForm(avaliacaoId: number, upfiles?: Array<Blob>, sobrescreverExistentes?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResultadoAnexosAvaliadosLote>>;
    public v1AvaliacaoAvaliacaoIdAvaliadosAnexosPostForm(avaliacaoId: number, upfiles?: Array<Blob>, sobrescreverExistentes?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (avaliacaoId === null || avaliacaoId === undefined) {
            throw new Error('Required parameter avaliacaoId was null or undefined when calling v1AvaliacaoAvaliacaoIdAvaliadosAnexosPost.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (sobrescreverExistentes !== undefined && sobrescreverExistentes !== null) {
            queryParameters = queryParameters.set('sobrescreverExistentes', <any>sobrescreverExistentes);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (upfiles) {
            upfiles.forEach((element) => {
                formParams = formParams.append('upfiles', <any>element) as any || formParams;
            })
        }

        return this.httpClient.request<ResultadoAnexosAvaliadosLote>('post',`${this.basePath}/v1/avaliacao/${encodeURIComponent(String(avaliacaoId))}/avaliados/anexos`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Remover Anexo do Avaliado
     * 
     * @param avaliacaoId 
     * @param avaliadoId 
     * @param anexoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosAnexoIdDelete(avaliacaoId: number, avaliadoId: number, anexoId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosAnexoIdDelete(avaliacaoId: number, avaliadoId: number, anexoId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosAnexoIdDelete(avaliacaoId: number, avaliadoId: number, anexoId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosAnexoIdDelete(avaliacaoId: number, avaliadoId: number, anexoId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (avaliacaoId === null || avaliacaoId === undefined) {
            throw new Error('Required parameter avaliacaoId was null or undefined when calling v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosAnexoIdDelete.');
        }

        if (avaliadoId === null || avaliadoId === undefined) {
            throw new Error('Required parameter avaliadoId was null or undefined when calling v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosAnexoIdDelete.');
        }

        if (anexoId === null || anexoId === undefined) {
            throw new Error('Required parameter anexoId was null or undefined when calling v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosAnexoIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/v1/avaliacao/${encodeURIComponent(String(avaliacaoId))}/avaliados/${encodeURIComponent(String(avaliadoId))}/anexos/${encodeURIComponent(String(anexoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Detalhes do Anexo do Avaliado
     * 
     * @param avaliacaoId 
     * @param avaliadoId 
     * @param anexoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosAnexoIdGet(avaliacaoId: number, avaliadoId: number, anexoId: number, observe?: 'body', reportProgress?: boolean): Observable<AnexoAvaliado>;
    public v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosAnexoIdGet(avaliacaoId: number, avaliadoId: number, anexoId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AnexoAvaliado>>;
    public v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosAnexoIdGet(avaliacaoId: number, avaliadoId: number, anexoId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AnexoAvaliado>>;
    public v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosAnexoIdGet(avaliacaoId: number, avaliadoId: number, anexoId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (avaliacaoId === null || avaliacaoId === undefined) {
            throw new Error('Required parameter avaliacaoId was null or undefined when calling v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosAnexoIdGet.');
        }

        if (avaliadoId === null || avaliadoId === undefined) {
            throw new Error('Required parameter avaliadoId was null or undefined when calling v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosAnexoIdGet.');
        }

        if (anexoId === null || anexoId === undefined) {
            throw new Error('Required parameter anexoId was null or undefined when calling v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosAnexoIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AnexoAvaliado>('get',`${this.basePath}/v1/avaliacao/${encodeURIComponent(String(avaliacaoId))}/avaliados/${encodeURIComponent(String(avaliadoId))}/anexos/${encodeURIComponent(String(anexoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar Anexos do Avaliado
     * 
     * @param avaliacaoId 
     * @param avaliadoId 
     * @param tipoAnexo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosGet(avaliacaoId: number, avaliadoId: number, tipoAnexo?: TipoAnexo, observe?: 'body', reportProgress?: boolean): Observable<Array<AnexoAvaliado>>;
    public v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosGet(avaliacaoId: number, avaliadoId: number, tipoAnexo?: TipoAnexo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AnexoAvaliado>>>;
    public v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosGet(avaliacaoId: number, avaliadoId: number, tipoAnexo?: TipoAnexo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AnexoAvaliado>>>;
    public v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosGet(avaliacaoId: number, avaliadoId: number, tipoAnexo?: TipoAnexo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (avaliacaoId === null || avaliacaoId === undefined) {
            throw new Error('Required parameter avaliacaoId was null or undefined when calling v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosGet.');
        }

        if (avaliadoId === null || avaliadoId === undefined) {
            throw new Error('Required parameter avaliadoId was null or undefined when calling v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosGet.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tipoAnexo !== undefined && tipoAnexo !== null) {
            queryParameters = queryParameters.set('tipoAnexo', <any>tipoAnexo);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<AnexoAvaliado>>('get',`${this.basePath}/v1/avaliacao/${encodeURIComponent(String(avaliacaoId))}/avaliados/${encodeURIComponent(String(avaliadoId))}/anexos`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Incluir Novo Anexo do Avaliado
     * 
     * @param tipoAnexo 
     * @param avaliacaoId 
     * @param avaliadoId 
     * @param upfile 
     * @param sobrescreverExistente 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosPostForm(tipoAnexo: TipoAnexo, avaliacaoId: number, avaliadoId: number, upfile?: Blob, sobrescreverExistente?: boolean, observe?: 'body', reportProgress?: boolean): Observable<AnexoAvaliado>;
    public v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosPostForm(tipoAnexo: TipoAnexo, avaliacaoId: number, avaliadoId: number, upfile?: Blob, sobrescreverExistente?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AnexoAvaliado>>;
    public v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosPostForm(tipoAnexo: TipoAnexo, avaliacaoId: number, avaliadoId: number, upfile?: Blob, sobrescreverExistente?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AnexoAvaliado>>;
    public v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosPostForm(tipoAnexo: TipoAnexo, avaliacaoId: number, avaliadoId: number, upfile?: Blob, sobrescreverExistente?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tipoAnexo === null || tipoAnexo === undefined) {
            throw new Error('Required parameter tipoAnexo was null or undefined when calling v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosPost.');
        }

        if (avaliacaoId === null || avaliacaoId === undefined) {
            throw new Error('Required parameter avaliacaoId was null or undefined when calling v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosPost.');
        }

        if (avaliadoId === null || avaliadoId === undefined) {
            throw new Error('Required parameter avaliadoId was null or undefined when calling v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdAnexosPost.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tipoAnexo !== undefined && tipoAnexo !== null) {
            queryParameters = queryParameters.set('tipoAnexo', <any>tipoAnexo);
        }
        if (sobrescreverExistente !== undefined && sobrescreverExistente !== null) {
            queryParameters = queryParameters.set('sobrescreverExistente', <any>sobrescreverExistente);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (upfile !== undefined) {
            formParams = formParams.append('upfile', <any>upfile) as any || formParams;
        }

        return this.httpClient.request<AnexoAvaliado>('post',`${this.basePath}/v1/avaliacao/${encodeURIComponent(String(avaliacaoId))}/avaliados/${encodeURIComponent(String(avaliadoId))}/anexos`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obter Resultados do Avaliado pelo Id
     * 
     * @param avaliacaoId 
     * @param avaliadoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdGet(avaliacaoId: number, avaliadoId: number, observe?: 'body', reportProgress?: boolean): Observable<Avaliado>;
    public v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdGet(avaliacaoId: number, avaliadoId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Avaliado>>;
    public v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdGet(avaliacaoId: number, avaliadoId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Avaliado>>;
    public v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdGet(avaliacaoId: number, avaliadoId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (avaliacaoId === null || avaliacaoId === undefined) {
            throw new Error('Required parameter avaliacaoId was null or undefined when calling v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdGet.');
        }

        if (avaliadoId === null || avaliadoId === undefined) {
            throw new Error('Required parameter avaliadoId was null or undefined when calling v1AvaliacaoAvaliacaoIdAvaliadosAvaliadoIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Avaliado>('get',`${this.basePath}/v1/avaliacao/${encodeURIComponent(String(avaliacaoId))}/avaliados/${encodeURIComponent(String(avaliadoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar Avaliados da Avaliação
     * 
     * @param avaliacaoId 
     * @param withoutChildren 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1AvaliacaoAvaliacaoIdAvaliadosGet(avaliacaoId: number, withoutChildren?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<Avaliado>>;
    public v1AvaliacaoAvaliacaoIdAvaliadosGet(avaliacaoId: number, withoutChildren?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Avaliado>>>;
    public v1AvaliacaoAvaliacaoIdAvaliadosGet(avaliacaoId: number, withoutChildren?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Avaliado>>>;
    public v1AvaliacaoAvaliacaoIdAvaliadosGet(avaliacaoId: number, withoutChildren?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (avaliacaoId === null || avaliacaoId === undefined) {
            throw new Error('Required parameter avaliacaoId was null or undefined when calling v1AvaliacaoAvaliacaoIdAvaliadosGet.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (withoutChildren !== undefined && withoutChildren !== null) {
            queryParameters = queryParameters.set('withoutChildren', <any>withoutChildren);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Avaliado>>('get',`${this.basePath}/v1/avaliacao/${encodeURIComponent(String(avaliacaoId))}/avaliados`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar Perfis da Ciência Configurados para a Avaliação
     * 
     * @param avaliacaoId 
     * @param cienciaId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1AvaliacaoAvaliacaoIdCienciaCienciaIdPerfisGet(avaliacaoId: number, cienciaId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<NewPerfil>>;
    public v1AvaliacaoAvaliacaoIdCienciaCienciaIdPerfisGet(avaliacaoId: number, cienciaId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<NewPerfil>>>;
    public v1AvaliacaoAvaliacaoIdCienciaCienciaIdPerfisGet(avaliacaoId: number, cienciaId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<NewPerfil>>>;
    public v1AvaliacaoAvaliacaoIdCienciaCienciaIdPerfisGet(avaliacaoId: number, cienciaId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (avaliacaoId === null || avaliacaoId === undefined) {
            throw new Error('Required parameter avaliacaoId was null or undefined when calling v1AvaliacaoAvaliacaoIdCienciaCienciaIdPerfisGet.');
        }

        if (cienciaId === null || cienciaId === undefined) {
            throw new Error('Required parameter cienciaId was null or undefined when calling v1AvaliacaoAvaliacaoIdCienciaCienciaIdPerfisGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<NewPerfil>>('get',`${this.basePath}/v1/avaliacao/${encodeURIComponent(String(avaliacaoId))}/ciencia/${encodeURIComponent(String(cienciaId))}/perfis`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Atualizar Configuração de Perfis da Ciência para Avaliação
     * 
     * @param body 
     * @param avaliacaoId 
     * @param cienciaId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1AvaliacaoAvaliacaoIdCienciaCienciaIdPerfisPut(body: Array<NewPerfil>, avaliacaoId: number, cienciaId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<NewPerfil>>;
    public v1AvaliacaoAvaliacaoIdCienciaCienciaIdPerfisPut(body: Array<NewPerfil>, avaliacaoId: number, cienciaId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<NewPerfil>>>;
    public v1AvaliacaoAvaliacaoIdCienciaCienciaIdPerfisPut(body: Array<NewPerfil>, avaliacaoId: number, cienciaId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<NewPerfil>>>;
    public v1AvaliacaoAvaliacaoIdCienciaCienciaIdPerfisPut(body: Array<NewPerfil>, avaliacaoId: number, cienciaId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling v1AvaliacaoAvaliacaoIdCienciaCienciaIdPerfisPut.');
        }

        if (avaliacaoId === null || avaliacaoId === undefined) {
            throw new Error('Required parameter avaliacaoId was null or undefined when calling v1AvaliacaoAvaliacaoIdCienciaCienciaIdPerfisPut.');
        }

        if (cienciaId === null || cienciaId === undefined) {
            throw new Error('Required parameter cienciaId was null or undefined when calling v1AvaliacaoAvaliacaoIdCienciaCienciaIdPerfisPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<NewPerfil>>('put',`${this.basePath}/v1/avaliacao/${encodeURIComponent(String(avaliacaoId))}/ciencia/${encodeURIComponent(String(cienciaId))}/perfis`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Excluir Avaliação pelo Id
     * 
     * @param avaliacaoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1AvaliacaoAvaliacaoIdDelete(avaliacaoId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public v1AvaliacaoAvaliacaoIdDelete(avaliacaoId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public v1AvaliacaoAvaliacaoIdDelete(avaliacaoId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public v1AvaliacaoAvaliacaoIdDelete(avaliacaoId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (avaliacaoId === null || avaliacaoId === undefined) {
            throw new Error('Required parameter avaliacaoId was null or undefined when calling v1AvaliacaoAvaliacaoIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/v1/avaliacao/${encodeURIComponent(String(avaliacaoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obter Avaliação pelo Id
     * 
     * @param avaliacaoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1AvaliacaoAvaliacaoIdGet(avaliacaoId: number, observe?: 'body', reportProgress?: boolean): Observable<Avaliacao>;
    public v1AvaliacaoAvaliacaoIdGet(avaliacaoId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Avaliacao>>;
    public v1AvaliacaoAvaliacaoIdGet(avaliacaoId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Avaliacao>>;
    public v1AvaliacaoAvaliacaoIdGet(avaliacaoId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (avaliacaoId === null || avaliacaoId === undefined) {
            throw new Error('Required parameter avaliacaoId was null or undefined when calling v1AvaliacaoAvaliacaoIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Avaliacao>('get',`${this.basePath}/v1/avaliacao/${encodeURIComponent(String(avaliacaoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Atualizar Avaliação a Partir da Importação do Arquivo CSV
     * 
     * @param avaliacaoId 
     * @param upfile 
     * @param enviarEmailInconsistencia 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1AvaliacaoAvaliacaoIdImportararquivoPutForm(avaliacaoId: number, upfile?: Blob, enviarEmailInconsistencia?: boolean, observe?: 'body', reportProgress?: boolean): Observable<ImportacaoPlanilha>;
    public v1AvaliacaoAvaliacaoIdImportararquivoPutForm(avaliacaoId: number, upfile?: Blob, enviarEmailInconsistencia?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ImportacaoPlanilha>>;
    public v1AvaliacaoAvaliacaoIdImportararquivoPutForm(avaliacaoId: number, upfile?: Blob, enviarEmailInconsistencia?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ImportacaoPlanilha>>;
    public v1AvaliacaoAvaliacaoIdImportararquivoPutForm(avaliacaoId: number, upfile?: Blob, enviarEmailInconsistencia?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (avaliacaoId === null || avaliacaoId === undefined) {
            throw new Error('Required parameter avaliacaoId was null or undefined when calling v1AvaliacaoAvaliacaoIdImportararquivoPut.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (enviarEmailInconsistencia !== undefined && enviarEmailInconsistencia !== null) {
            queryParameters = queryParameters.set('enviarEmailInconsistencia', <any>enviarEmailInconsistencia);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (upfile !== undefined) {
            formParams = formParams.append('upfile', <any>upfile) as any || formParams;
        }

        return this.httpClient.request<ImportacaoPlanilha>('put',`${this.basePath}/v1/avaliacao/${encodeURIComponent(String(avaliacaoId))}/importararquivo`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obter Planilha Excel da Avaliação pelo Id
     * 
     * @param avaliacaoId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1AvaliacaoAvaliacaoIdObterplanilhaPut(avaliacaoId: number, body?: ExportFilter, observe?: 'body', reportProgress?: boolean): Observable<MicrosoftAspNetCoreMvcFileContentResult>;
    public v1AvaliacaoAvaliacaoIdObterplanilhaPut(avaliacaoId: number, body?: ExportFilter, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MicrosoftAspNetCoreMvcFileContentResult>>;
    public v1AvaliacaoAvaliacaoIdObterplanilhaPut(avaliacaoId: number, body?: ExportFilter, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MicrosoftAspNetCoreMvcFileContentResult>>;
    public v1AvaliacaoAvaliacaoIdObterplanilhaPut(avaliacaoId: number, body?: ExportFilter, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (avaliacaoId === null || avaliacaoId === undefined) {
            throw new Error('Required parameter avaliacaoId was null or undefined when calling v1AvaliacaoAvaliacaoIdObterplanilhaPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request('put',`${this.basePath}/v1/avaliacao/${encodeURIComponent(String(avaliacaoId))}/obterplanilha`,
            {
                body: body,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar Avaliações do Cliente
     * 
     * @param pessoaJuridicaId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1AvaliacaoClientePessoaJuridicaIdGet(pessoaJuridicaId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<Avaliacao>>;
    public v1AvaliacaoClientePessoaJuridicaIdGet(pessoaJuridicaId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Avaliacao>>>;
    public v1AvaliacaoClientePessoaJuridicaIdGet(pessoaJuridicaId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Avaliacao>>>;
    public v1AvaliacaoClientePessoaJuridicaIdGet(pessoaJuridicaId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (pessoaJuridicaId === null || pessoaJuridicaId === undefined) {
            throw new Error('Required parameter pessoaJuridicaId was null or undefined when calling v1AvaliacaoClientePessoaJuridicaIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Avaliacao>>('get',`${this.basePath}/v1/avaliacao/cliente/${encodeURIComponent(String(pessoaJuridicaId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar Avaliações
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1AvaliacaoGet(observe?: 'body', reportProgress?: boolean): Observable<Array<Avaliacao>>;
    public v1AvaliacaoGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Avaliacao>>>;
    public v1AvaliacaoGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Avaliacao>>>;
    public v1AvaliacaoGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Avaliacao>>('get',`${this.basePath}/v1/avaliacao`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar Importações de Planilhas
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1AvaliacaoImportacaoGet(observe?: 'body', reportProgress?: boolean): Observable<Array<ImportacaoPlanilha>>;
    public v1AvaliacaoImportacaoGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ImportacaoPlanilha>>>;
    public v1AvaliacaoImportacaoGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ImportacaoPlanilha>>>;
    public v1AvaliacaoImportacaoGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ImportacaoPlanilha>>('get',`${this.basePath}/v1/avaliacao/importacao`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obter Importação da Planilha pelo Id
     * 
     * @param importacaoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1AvaliacaoImportacaoImportacaoIdGet(importacaoId: number, observe?: 'body', reportProgress?: boolean): Observable<ImportacaoPlanilha>;
    public v1AvaliacaoImportacaoImportacaoIdGet(importacaoId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ImportacaoPlanilha>>;
    public v1AvaliacaoImportacaoImportacaoIdGet(importacaoId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ImportacaoPlanilha>>;
    public v1AvaliacaoImportacaoImportacaoIdGet(importacaoId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (importacaoId === null || importacaoId === undefined) {
            throw new Error('Required parameter importacaoId was null or undefined when calling v1AvaliacaoImportacaoImportacaoIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ImportacaoPlanilha>('get',`${this.basePath}/v1/avaliacao/importacao/${encodeURIComponent(String(importacaoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obter Avaliação pelo Id do Serviço
     * 
     * @param servicoId 
     * @param withoutChildren 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1AvaliacaoServicoServicoIdGet(servicoId: number, withoutChildren?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<Avaliacao>>;
    public v1AvaliacaoServicoServicoIdGet(servicoId: number, withoutChildren?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Avaliacao>>>;
    public v1AvaliacaoServicoServicoIdGet(servicoId: number, withoutChildren?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Avaliacao>>>;
    public v1AvaliacaoServicoServicoIdGet(servicoId: number, withoutChildren?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (servicoId === null || servicoId === undefined) {
            throw new Error('Required parameter servicoId was null or undefined when calling v1AvaliacaoServicoServicoIdGet.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (withoutChildren !== undefined && withoutChildren !== null) {
            queryParameters = queryParameters.set('withoutChildren', <any>withoutChildren);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Avaliacao>>('get',`${this.basePath}/v1/avaliacao/servico/${encodeURIComponent(String(servicoId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Incluir Nova Avaliação a Partir da Importação do Arquivo CSV
     * 
     * @param servicoId 
     * @param upfile 
     * @param enviarEmailInconsistencia 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1AvaliacaoServicoServicoIdImportararquivoPostForm(servicoId: number, upfile?: Blob, enviarEmailInconsistencia?: boolean, observe?: 'body', reportProgress?: boolean): Observable<ImportacaoPlanilha>;
    public v1AvaliacaoServicoServicoIdImportararquivoPostForm(servicoId: number, upfile?: Blob, enviarEmailInconsistencia?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ImportacaoPlanilha>>;
    public v1AvaliacaoServicoServicoIdImportararquivoPostForm(servicoId: number, upfile?: Blob, enviarEmailInconsistencia?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ImportacaoPlanilha>>;
    public v1AvaliacaoServicoServicoIdImportararquivoPostForm(servicoId: number, upfile?: Blob, enviarEmailInconsistencia?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (servicoId === null || servicoId === undefined) {
            throw new Error('Required parameter servicoId was null or undefined when calling v1AvaliacaoServicoServicoIdImportararquivoPost.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (enviarEmailInconsistencia !== undefined && enviarEmailInconsistencia !== null) {
            queryParameters = queryParameters.set('enviarEmailInconsistencia', <any>enviarEmailInconsistencia);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (upfile !== undefined) {
            formParams = formParams.append('upfile', <any>upfile) as any || formParams;
        }

        return this.httpClient.request<ImportacaoPlanilha>('post',`${this.basePath}/v1/avaliacao/servico/${encodeURIComponent(String(servicoId))}/importararquivo`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
